import { Injectable } from "@angular/core";
import { FetchStatusSelector } from "@obg/ngrx-utils";

import { CommonState } from "../../state";

import { ACTION_PREFIX } from "./marketing-settings.action";
import { Consents, MarketingSettings, MarketingSettingsError } from "./marketing-settings.model";

@Injectable({
	providedIn: "root",
})
export class MarketingSettingsSelector {
	getConsents() {
		return (state: CommonState): Consents | undefined => state.marketingSettings.consents;
	}

	getMissingMarketingSettings() {
		return (state: CommonState): MarketingSettings | undefined => state.marketingSettings.missingMarketingSettings;
	}

	isConsentsMarketingSettingsFilled() {
		return (state: CommonState): boolean =>
			!!state.marketingSettings.missingMarketingSettings &&
			state.marketingSettings.missingMarketingSettings.consents &&
			!state.marketingSettings.missingMarketingSettings.consents.groupMarketing &&
			!state.marketingSettings.missingMarketingSettings.consents.brandMarketing;
	}

	getMissingMarketingSettingsDetails() {
		return (state: CommonState): MarketingSettings | undefined =>
			state.marketingSettings.missingMarketingSettingsDetails;
	}

	isBusy() {
		return (state: CommonState): boolean => FetchStatusSelector.isBusy(ACTION_PREFIX)(state);
	}

	isConsentsNotFound() {
		return (state: CommonState): boolean => !!state.marketingSettings.isConsentsNotFound;
	}

	hasGivenConsents() {
		return (state: CommonState): boolean | undefined => state.marketingSettings.hasGivenConsents;
	}

	getError() {
		return (state: CommonState): MarketingSettingsError | undefined => state.marketingSettings.error;
	}
}
